import { WorkspaceProductSlice } from 'features/performance/forms'
import { useLazyQuery } from 'providers/tanstack-query/useLazyQuery'
import { workspaceProductSliceFromDTO } from './api/mapper'
import { GET_WORKSPACE_FOR_FORM } from './api/query'
import { Data, Variables } from './api/types'
import { UseGetWorkspaceProduct, UseGetWorkspaceProductProps } from './types'

export const useGetWorkspaceProduct = ({
  id,
  product,
}: UseGetWorkspaceProductProps): UseGetWorkspaceProduct => {
  const { lazyFetch } = useLazyQuery<Variables, Data, WorkspaceProductSlice>({
    options: {
      select: ({ node }: Data): null | WorkspaceProductSlice => {
        if (product === undefined || node === null) {
          return null
        }

        return workspaceProductSliceFromDTO(node, product)
      },
    },
    query: GET_WORKSPACE_FOR_FORM,
    variables: { id: id! },
  })

  const lazyGet = async (): Promise<null | WorkspaceProductSlice> => {
    return (await lazyFetch()).data ?? null
  }

  return { lazyGet }
}
